import config from '../config/config';
import { GAME_ID, NUM_LEVELS } from '../data/constants';

const initialState = {
  // selected level on progress screen
  currentLevel: 1,
  rewardBowlState: 0,
  picturesOnboardingDipslayed: false,
  wordsOnboardingDisplayed: false,
  masteredLevels: [],
  // corresponds to levels available for user to play
  // incremented each time user finished level
  highestLevelEarned: 1,
  displayAnimationOnLoad: 0,
  zapsEarned: 0,
  bitesEarned: 0,
  roundCounters: {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
  },
};

const sessionReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case 'SELECT_LEVEL':
      return { ...state, currentLevel: action.payload.level };
    case 'NEXT_LEVEL':
      return {
        ...state,
        // highest level earned should not be grater then max available level
        highestLevelEarned:
          state.currentLevel >= config.availableLevels
            ? state.currentLevel
            : state.currentLevel + 1,
        masteredLevels: [...state.masteredLevels, state.highestLevelEarned],
      };
    case 'DISPLAY_WORDS_ONBOARDING':
      return { ...state, wordsOnboardingDisplayed: true };
    case 'DISPLAY_PICTURES_ONBOARDING':
      return { ...state, picturesOnboardingDipslayed: true };
    case 'ADD_ZAPS_EARNED':
      return {
        ...state,
        zapsEarned: state.zapsEarned + action.payload.zapsEarned,
      };
    case 'ADD_BITES_EARNED':
      return {
        ...state,
        bitesEarned: state.bitesEarned + action.payload.bitesEarned,
      };
    case 'INCREMENT_ROUND_COUNTER': {
      const newState = state;
      newState.roundCounters[action.payload.level] += 1;
      return newState;
    }
    case 'SET_REWARD_BOWL_STATE':
      return {
        ...state,
        rewardBowlState: action.payload.state,
        displayAnimationOnLoad: action.payload.state,
      };
    case 'RESET_BOWL_ANIMATION':
      return { ...state, displayAnimationOnLoad: 0 };
    case 'RESET_BOWL':
      return { ...state, rewardBowlState: 0 };
    default:
      return state;
  }
};

export const selectLevelsMastered = (state) => {
  const levelsMastered = new Array(NUM_LEVELS).fill(false);
  state.masteredLevels.forEach((levelNumber) => {
    levelsMastered[levelNumber - 1] = true;
  });
  return levelsMastered;
};

export default sessionReducer;
